import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

import { radioInputHandler } from './input.helpers';

const toControlLabelProps = ({ label, value }, { disabled }) => ({
	disabled,
	key: value,
	label,
	value,
});

const RadioGroupWidget = props => {
	const { onChange, options, ...otherProps } = props;

	if (!Array.isArray(options)) {
		return null;
	}
	const handler = radioInputHandler(onChange);
	return (
		<RadioGroup {...otherProps} onChange={handler}>
			{options &&
				options.map(option => {
					return (
						<FormControlLabel
							{...toControlLabelProps(option, otherProps)}
							control={<Radio color="primary" disableRipple />}
						/>
					);
				})}
		</RadioGroup>
	);
};

RadioGroupWidget.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	options: PropTypes.array,
};

export default RadioGroupWidget;
